import { Directive, TemplateRef, ViewChild } from "@angular/core";

@Directive()
export class AdminTableCell {
    @ViewChild(TemplateRef)
    public cellContent: TemplateRef<any>;
}